/* eslint-disable max-classes-per-file */ function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _asyncToGenerator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) {
        throw new TypeError("Cannot call a class as a function");
    }
}
function _defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, descriptor.key, descriptor);
    }
}
function _createClass(Constructor, protoProps, staticProps) {
    if (protoProps) _defineProperties(Constructor.prototype, protoProps);
    if (staticProps) _defineProperties(Constructor, staticProps);
    return Constructor;
}
var __generator = this && this.__generator || function(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
};
import { isLocalStorageAvailable } from "@kaggle/core";
import { featureFlags } from "../featureFlags";
import { blobsClient } from "../generated/blobs";
import { kernelsClient } from "../stub/sdk/kernelsClient/kernelsClient";
export var UploadProgress = /*#__PURE__*/ function() {
    "use strict";
    function UploadProgress(initializers) {
        _classCallCheck(this, UploadProgress);
        // REVIEW: look at text to see if it can be improved?
        /** User-friendly description of the current state of the upload. */ this.description = "Not started";
        /** Indicates if the upload is currently sending blob bytes */ this.isUploading = false;
        /** Is the upload currently in a paused state? */ this.isPaused = false;
        this.hasSucceeded = false;
        this.hasFailed = false;
        if (initializers) {
            Object.assign(this, initializers);
        }
    }
    _createClass(UploadProgress, [
        {
            key: "hasStarted",
            get: // REVIEW: Better names?
            function get() {
                return !!this.uploadProgressEvent;
            }
        },
        {
            key: "totalBytesLoaded",
            get: function get() {
                return (this.uploadProgressEvent && this.uploadProgressEvent.loaded || 0) + (this.previousBytesReceived || 0);
            }
        },
        {
            key: "isDone",
            get: /** Did the upload finish? */ function get() {
                return this.hasSucceeded || this.hasFailed;
            }
        },
        {
            key: "progressProps",
            get: function get() {
                return {
                    initiatedTimeStamp: this.initialProgressEventTimeStamp,
                    initialOffsetAmount: this.previousBytesReceived,
                    progressEvent: this.uploadProgressEvent
                };
            }
        }
    ]);
    return UploadProgress;
}();
// TODO(jeffmoser): Move to a different file?
// Based off the .NET concept of the same name:
export var CancellationToken = /*#__PURE__*/ function() {
    "use strict";
    function CancellationToken() {
        _classCallCheck(this, CancellationToken);
        this.cancellationCallbacks = [];
        this._isCancellationRequested = false;
    }
    var _proto = CancellationToken.prototype;
    /**
   * Registers a callback that will be called when the token is cancelled.
   * @param callback to invoke when the token is cancelled.
   * @returns A function that unregisters the callback.
   */ _proto.register = function register(callback) {
        var _this = this;
        if (this.isCancellationRequested) {
            callback();
        }
        this.cancellationCallbacks.push(callback);
        return function() {
            // Remove it from the list
            _this.cancellationCallbacks = _this.cancellationCallbacks.filter(function(cb) {
                return cb !== callback;
            });
        };
    };
    // For simplicity, we have a "cancel" method directly on the token (unlike .NET)
    _proto.cancel = function cancel() {
        if (this.isCancellationRequested) {
            // Only invoke once
            return;
        }
        this._isCancellationRequested = true;
        var _iteratorNormalCompletion = true, _didIteratorError = false, _iteratorError = undefined;
        try {
            for(var _iterator = this.cancellationCallbacks[Symbol.iterator](), _step; !(_iteratorNormalCompletion = (_step = _iterator.next()).done); _iteratorNormalCompletion = true){
                var callback = _step.value;
                if (callback) {
                    callback();
                }
            }
        } catch (err) {
            _didIteratorError = true;
            _iteratorError = err;
        } finally{
            try {
                if (!_iteratorNormalCompletion && _iterator.return != null) {
                    _iterator.return();
                }
            } finally{
                if (_didIteratorError) {
                    throw _iteratorError;
                }
            }
        }
    };
    _createClass(CancellationToken, [
        {
            key: "isCancellationRequested",
            get: function get() {
                return this._isCancellationRequested;
            }
        }
    ]);
    return CancellationToken;
}();
// HACK: another idea borrowed from .NET:
// eslint-disable-next-line max-classes-per-file
var ManualResetEvent = /*#__PURE__*/ function() {
    "use strict";
    function ManualResetEvent() {
        _classCallCheck(this, ManualResetEvent);
        // eslint-disable-next-line no-empty,no-empty-function,@typescript-eslint/no-empty-function
        this.internalResolve = function() {};
        this.internalPromise = Promise.resolve();
        this.reset();
    }
    var _proto = ManualResetEvent.prototype;
    _proto.set = function set() {
        if (this.internalResolve) {
            this.internalResolve();
        }
    };
    _proto.wait = function wait() {
        return this.internalPromise;
    };
    _proto.reset = function reset() {
        var _this = this;
        this.internalPromise = new Promise(function(resolve) {
            _this.internalResolve = resolve;
        });
    };
    return ManualResetEvent;
}();
// REVIEW: need a better name?
// eslint-disable-next-line max-classes-per-file
var AsyncPauser = /*#__PURE__*/ function() {
    "use strict";
    function AsyncPauser() {
        _classCallCheck(this, AsyncPauser);
        this.isPaused = false;
        this.resumeEvent = null;
        this.currentCancellationToken = new CancellationToken();
    }
    var _proto = AsyncPauser.prototype;
    _proto.pause = function pause() {
        if (this.isPaused) {
            return;
        }
        this.isPaused = true;
        this.resumeEvent = new ManualResetEvent();
        this.currentCancellationToken.cancel();
    };
    _proto.waitUntilResumed = function waitUntilResumed() {
        var _this = this;
        return _asyncToGenerator(function() {
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        if (!_this.isPaused || _this.resumeEvent === null) {
                            return [
                                2
                            ];
                        }
                        return [
                            4,
                            _this.resumeEvent.wait()
                        ];
                    case 1:
                        _state.sent();
                        return [
                            2
                        ];
                }
            });
        })();
    };
    _proto.resume = function resume() {
        if (!this.isPaused || this.resumeEvent === null) {
            return;
        }
        this.isPaused = false;
        this.currentCancellationToken = new CancellationToken();
        this.resumeEvent.set();
        this.resumeEvent = null;
    };
    return AsyncPauser;
}();
var sleep = function() {
    var _ref = _asyncToGenerator(function(ms) {
        return __generator(this, function(_state) {
            return [
                2,
                new Promise(function(resolve) {
                    return window.setTimeout(resolve, ms);
                })
            ];
        });
    });
    return function sleep(ms) {
        return _ref.apply(this, arguments);
    };
}();
function getExistingGcsUploadBytesReceived(sessionUrl, blob, onProgress) {
    return _getExistingGcsUploadBytesReceived.apply(this, arguments);
}
function _getExistingGcsUploadBytesReceived() {
    _getExistingGcsUploadBytesReceived = // REVIEW: Should these just be local functions inside the upload closure rather than breaking them out like this?
    _asyncToGenerator(function(sessionUrl, blob, onProgress) {
        var response, _tmp, rangeHeader, rangeMatch, startByteOffset, endByteOffset;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    onProgress(new UploadProgress({
                        description: "Checking server for existing upload"
                    }));
                    return [
                        4,
                        fetch(sessionUrl, {
                            method: "PUT",
                            headers: {
                                "Content-Range": "bytes */".concat(blob.size)
                            }
                        })
                    ];
                case 1:
                    response = _state.sent();
                    if (!(response.status >= 200 && response.status < 300)) return [
                        3,
                        3
                    ];
                    _tmp = {
                        bytesReceived: blob.size
                    };
                    return [
                        4,
                        response.json()
                    ];
                case 2:
                    // Assume we're already done
                    // REVIEW: What does the real GCS return?
                    return [
                        2,
                        (_tmp.completeBlob = _state.sent(), _tmp)
                    ];
                case 3:
                    rangeHeader = response.headers.get("Range");
                    if (rangeHeader) {
                        rangeMatch = rangeHeader.match(/bytes\s*=\s*([0-9]+)-([0-9]+)/);
                        if (!rangeMatch) {
                            throw new Error("Unable to parse Range header: ".concat(rangeHeader));
                        }
                        startByteOffset = parseInt(rangeMatch[1], 10);
                        if (startByteOffset !== 0) {
                            throw new Error("Unexpect Range start offset: ".concat(startByteOffset));
                        }
                        endByteOffset = parseInt(rangeMatch[2], 10);
                        if (endByteOffset >= blob.size) {
                            throw new Error("Range end is larger than expected: ".concat(endByteOffset));
                        }
                        return [
                            2,
                            {
                                bytesReceived: endByteOffset + 1
                            }
                        ];
                    }
                    return [
                        2,
                        {
                            bytesReceived: 0
                        }
                    ];
            }
        });
    });
    return _getExistingGcsUploadBytesReceived.apply(this, arguments);
}
var daysSinceUnixMillis = function(then) {
    var now = new Date();
    return (now.getTime() - then) / (1000 * 3600 * 24);
};
var MAX_DAYS_USING_PROXY = 1;
function shouldUseProxy() {
    return featureFlags.kernelsGCSUploadProxy || failedOver || // This is the Firebase proxy detection logic, if Firebase is falling back
    // we probably should here too:
    isLocalStorageAvailable() && !!localStorage.useProxy && daysSinceUnixMillis(localStorage.useProxyUpdateTime) < MAX_DAYS_USING_PROXY;
}
var failedOver = false;
function proxyFailover() {
    if (!shouldUseProxy()) {
        // Enable proxying, allow higher-level retries to retry proxied.
        failedOver = true;
        // If we have local storage, lets remember that we failed over:
        if (isLocalStorageAvailable()) {
            localStorage.useProxy = true;
            var now = new Date();
            localStorage.useProxyUpdateTime = now.getTime();
        }
    }
}
var configPromise;
function proxyConfig() {
    if (!configPromise) {
        configPromise = kernelsClient.kernelsService.getFirebaseConfig({});
    }
    return configPromise;
}
function proxyURL(url) {
    return _proxyURL.apply(this, arguments);
}
function _proxyURL() {
    _proxyURL = _asyncToGenerator(function(url) {
        var config;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!shouldUseProxy()) {
                        return [
                            2,
                            url
                        ];
                    }
                    return [
                        4,
                        proxyConfig()
                    ];
                case 1:
                    config = _state.sent();
                    if (config.proxyDomain) {
                        return [
                            2,
                            url.replace("www.googleapis.com", config.proxyDomain)
                        ];
                    }
                    return [
                        2,
                        url
                    ];
            }
        });
    });
    return _proxyURL.apply(this, arguments);
}
function proxyDownloadURL(url) {
    return _proxyDownloadURL.apply(this, arguments);
}
function _proxyDownloadURL() {
    _proxyDownloadURL = _asyncToGenerator(function(url) {
        var config;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    if (!shouldUseProxy()) {
                        return [
                            2,
                            url
                        ];
                    }
                    return [
                        4,
                        proxyConfig()
                    ];
                case 1:
                    config = _state.sent();
                    if (config.proxyDomain) {
                        return [
                            2,
                            url.replace("storage.googleapis.com", config.proxyDomain + "/download/storage")
                        ];
                    }
                    return [
                        2,
                        url
                    ];
            }
        });
    });
    return _proxyDownloadURL.apply(this, arguments);
}
function retry(fn, settings) {
    return _retry.apply(this, arguments);
}
function _retry() {
    _retry = _asyncToGenerator(function(fn, settings) {
        var delay, attempts, e;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    delay = settings.delayStart;
                    attempts = 0;
                    _state.label = 1;
                case 1:
                    if (!(attempts < settings.retries)) return [
                        3,
                        7
                    ];
                    _state.label = 2;
                case 2:
                    _state.trys.push([
                        2,
                        4,
                        ,
                        6
                    ]);
                    return [
                        4,
                        Promise.resolve(fn())
                    ];
                case 3:
                    return [
                        2,
                        _state.sent()
                    ];
                case 4:
                    e = _state.sent();
                    settings.failover();
                    return [
                        4,
                        sleep(delay * 1000)
                    ];
                case 5:
                    _state.sent();
                    delay = Math.min(delay * 2, settings.delayMax);
                    return [
                        3,
                        6
                    ];
                case 6:
                    attempts++;
                    return [
                        3,
                        1
                    ];
                case 7:
                    return [
                        2,
                        fn()
                    ];
            }
        });
    });
    return _retry.apply(this, arguments);
}
export function gcsDownload(url) {
    return _gcsDownload.apply(this, arguments);
}
function _gcsDownload() {
    _gcsDownload = _asyncToGenerator(function(url) {
        return __generator(this, function(_state) {
            return [
                2,
                retry(/*#__PURE__*/ _asyncToGenerator(function() {
                    return __generator(this, function(_state) {
                        switch(_state.label){
                            case 0:
                                return [
                                    4,
                                    proxyDownloadURL(url)
                                ];
                            case 1:
                                return [
                                    2,
                                    fetch.apply(void 0, [
                                        _state.sent()
                                    ])
                                ];
                        }
                    });
                }), {
                    retries: 10,
                    delayStart: 2,
                    delayMax: 30,
                    failover: proxyFailover
                })
            ];
        });
    });
    return _gcsDownload.apply(this, arguments);
}
export function putGcsBlob(sessionUrl, blob, contentType, attemptResume, onProgress, cancellationToken) {
    return _putGcsBlob.apply(this, arguments);
}
function _putGcsBlob() {
    _putGcsBlob = _asyncToGenerator(function(sessionUrl, blob, contentType, attemptResume, onProgress, cancellationToken) {
        var getExistingBlobInfo;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    return [
                        4,
                        proxyURL(sessionUrl)
                    ];
                case 1:
                    sessionUrl = _state.sent();
                    getExistingBlobInfo = attemptResume ? getExistingGcsUploadBytesReceived(sessionUrl, blob, onProgress) : Promise.resolve({
                        bytesReceived: 0
                    });
                    return [
                        2,
                        getExistingBlobInfo.then(function(existingInfo) {
                            return new Promise(function(resolve, reject) {
                                if (existingInfo.bytesReceived === blob.size && blob.size > 0 && existingInfo.completeBlob) {
                                    // I guess we're done here.
                                    // REVIEW: Can we fetch metadata from the sessionUrl?
                                    resolve(existingInfo.completeBlob);
                                    return;
                                }
                                var uploadProgress = new UploadProgress({
                                    previousBytesReceived: existingInfo.bytesReceived ? existingInfo.bytesReceived : 0
                                });
                                var xhr = new XMLHttpRequest();
                                xhr.open("PUT", sessionUrl);
                                xhr.upload.onprogress = function(progressEvent) {
                                    uploadProgress.description = "Uploading file";
                                    uploadProgress.isUploading = true;
                                    uploadProgress.isPaused = false;
                                    if (!uploadProgress.initialProgressEventTimeStamp) {
                                        uploadProgress.initialProgressEventTimeStamp = progressEvent.timeStamp;
                                    }
                                    uploadProgress.uploadProgressEvent = progressEvent;
                                    onProgress(uploadProgress);
                                };
                                // REVIEW: Should we listen to the xhr.upload.onerror and onload or the xhr one?
                                // Using the xhr one because that at least gives xhr.status
                                xhr.onerror = function() {
                                    uploadProgress.isUploading = false;
                                    if (cancellationToken && cancellationToken.isCancellationRequested) {
                                        // Ignore the rejection because the cancel will do that with a different error message
                                        return;
                                    }
                                    proxyFailover();
                                    reject(xhr.statusText);
                                };
                                xhr.onload = function() {
                                    uploadProgress.isUploading = false;
                                    if (xhr.status >= 200 && xhr.status < 300) {
                                        uploadProgress.isUploading = false;
                                        uploadProgress.isPaused = false;
                                        onProgress(uploadProgress);
                                        var response = JSON.parse(xhr.responseText);
                                        resolve(response);
                                    } else {
                                        uploadProgress.description = "Upload was interrupted";
                                        onProgress(uploadProgress);
                                        proxyFailover();
                                        reject(xhr.statusText);
                                    }
                                };
                                if (cancellationToken) {
                                    cancellationToken.register(function() {
                                        xhr.abort();
                                        uploadProgress.description = "Upload was paused";
                                        uploadProgress.isUploading = false;
                                        uploadProgress.isPaused = false;
                                        onProgress(uploadProgress);
                                        reject("Upload was cancelled");
                                    });
                                }
                                // Should we do anything special to support additional compression?
                                if (existingInfo.bytesReceived > 0) {
                                    xhr.setRequestHeader("Content-Range", "bytes ".concat(existingInfo.bytesReceived, "-").concat(blob.size - 1, "/").concat(blob.size));
                                    xhr.send(blob.slice(existingInfo.bytesReceived, blob.size, contentType));
                                } else {
                                    // REVIEW: does this send Content-Type?
                                    xhr.send(blob);
                                }
                            });
                        })
                    ];
            }
        });
    });
    return _putGcsBlob.apply(this, arguments);
}
/**
 * Uploads a blob to the specified URL.
 * @param blobBucket The destination bucket.
 * @param blob The HTML5 Blob to upload.
 * @param name The filename that the blob represents.
 * @param contentType The content type of the blob.
 * @param lastModifiedDate The local time when the file was last modified (used to hint timestamp to server).
 * @param onProgress Optional progress handler (suitable for end-user display)
 */ export function uploadBlob(blobBucket, blob, name, contentType, lastModifiedDate, onProgress) {
    var internalProgressHandler = function internalProgressHandler(currentProgress) {
        progressStateContainer.progress = currentProgress;
        if (progressStateContainer.onProgress) {
            progressStateContainer.onProgress(currentProgress);
        }
    };
    var createSession = function() {
        var _ref = _asyncToGenerator(function() {
            var request;
            return __generator(this, function(_state) {
                request = {
                    bucket: blobBucket,
                    name: name,
                    contentLength: blob.size,
                    contentType: contentType,
                    lastUpdateTime: lastModifiedDate
                };
                return [
                    2,
                    blobsClient.blobService.startBlobUpload(request)
                ];
            });
        });
        return function createSession() {
            return _ref.apply(this, arguments);
        };
    }();
    var asyncPauser = new AsyncPauser();
    var internalUpload = function() {
        var _ref = _asyncToGenerator(function(localOnProgress) {
            var sessionInfo, maxAttempts, delaySeconds, ixAttempt, attemptResume, gcsBlobInfo, decodedMd5Hash, rawMd5HashBytes, ixByte, uploadedBlobInfo, e, failureMessage;
            return __generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        // Fetch the session info from the server
                        localOnProgress(new UploadProgress({
                            description: "Initializing upload"
                        }));
                        return [
                            4,
                            createSession()
                        ];
                    case 1:
                        sessionInfo = _state.sent();
                        maxAttempts = 5000; // setting extremely high to still have _some_ limit (and prevent infinite loop)
                        delaySeconds = 2;
                        ixAttempt = 0;
                        _state.label = 2;
                    case 2:
                        if (!(ixAttempt < maxAttempts)) return [
                            3,
                            11
                        ];
                        _state.label = 3;
                    case 3:
                        _state.trys.push([
                            3,
                            5,
                            ,
                            10
                        ]);
                        attemptResume = ixAttempt !== 0;
                        return [
                            4,
                            putGcsBlob(sessionInfo.createUrl, blob, contentType, attemptResume, localOnProgress, asyncPauser.currentCancellationToken)
                        ];
                    case 4:
                        gcsBlobInfo = _state.sent();
                        decodedMd5Hash = null;
                        // GCS will return the MD5 Hash as a base64-encoded value. Let's make it more user-readable
                        if (gcsBlobInfo.md5Hash) {
                            decodedMd5Hash = "";
                            rawMd5HashBytes = atob(gcsBlobInfo.md5Hash);
                            for(ixByte = 0; ixByte < rawMd5HashBytes.length; ixByte++){
                                decodedMd5Hash += rawMd5HashBytes.charCodeAt(ixByte).toString(16);
                            }
                        }
                        uploadedBlobInfo = {
                            token: sessionInfo.token,
                            md5Hash: decodedMd5Hash,
                            name: name,
                            size: blob.size,
                            // This is used by the MarkdownEditor's image uploader.
                            mediaLink: gcsBlobInfo === null || gcsBlobInfo === void 0 ? void 0 : gcsBlobInfo.mediaLink
                        };
                        // Give one final progress event
                        localOnProgress(new UploadProgress({
                            description: "Upload complete",
                            uploadedBlobInfo: uploadedBlobInfo,
                            hasSucceeded: true
                        }));
                        return [
                            2,
                            uploadedBlobInfo
                        ];
                    case 5:
                        e = _state.sent();
                        if (!asyncPauser.isPaused) return [
                            3,
                            7
                        ];
                        return [
                            4,
                            asyncPauser.waitUntilResumed()
                        ];
                    case 6:
                        _state.sent();
                        return [
                            3,
                            10
                        ];
                    case 7:
                        if (!(ixAttempt > 1)) return [
                            3,
                            9
                        ];
                        localOnProgress(new UploadProgress({
                            description: "Error while uploading",
                            isPaused: true,
                            nextRetryDate: new Date(Date.now() + delaySeconds * 1000),
                            totalRetries: ixAttempt
                        }));
                        return [
                            4,
                            sleep(delaySeconds * 1000)
                        ];
                    case 8:
                        _state.sent();
                        delaySeconds = Math.min(delaySeconds * 2, 30);
                        _state.label = 9;
                    case 9:
                        return [
                            3,
                            10
                        ];
                    case 10:
                        ixAttempt++;
                        return [
                            3,
                            2
                        ];
                    case 11:
                        failureMessage = "Upload failed, even after ".concat(maxAttempts, " attempts");
                        localOnProgress(new UploadProgress({
                            description: failureMessage,
                            isUploading: false
                        }));
                        throw new Error(failureMessage);
                }
            });
        });
        return function internalUpload(localOnProgress) {
            return _ref.apply(this, arguments);
        };
    }();
    // REVIEW: this is just here for storing mutable state from the Promise's setters
    // Could possibly be refactored to a container or some other eventing?
    var progressStateContainer = {
        progress: new UploadProgress(),
        onProgress: onProgress
    };
    var uploadPromise = internalUpload(internalProgressHandler);
    var result = Object.defineProperties(uploadPromise, {
        pause: {
            value: function() {
                asyncPauser.pause();
                return function() {
                    asyncPauser.resume();
                    // We return the same Promise because it was technically never done
                    return uploadPromise;
                };
            },
            configurable: false,
            writable: false,
            enumerable: true
        },
        progress: {
            get: function() {
                return progressStateContainer.progress;
            },
            configurable: false,
            enumerable: true
        },
        onProgress: {
            get: function() {
                return progressStateContainer.onProgress;
            },
            set: function(op) {
                return progressStateContainer.onProgress = op;
            },
            configurable: false,
            enumerable: true
        }
    });
    return result;
}
/**
 * Uploads a file to the specified URL.
 * @param blobBucket The destination blob bucket.
 * @param file The HTML5 File to upload.
 * @param onProgress Optional progress handler (suitable for end-user display).
 */ export function uploadFile(blobBucket, file, onProgress) {
    return uploadBlob(blobBucket, file, file.name, file.type, new Date(file.lastModified), onProgress);
}
/**
 * Mock of uploadFile which just sleeps relative to the filesize and invokes onProgress accordingly.
 * Intended only for storybook / test use.
 */ export function mockUploadFile(file, onProgress) {
    return _mockUploadFile.apply(this, arguments);
}
function _mockUploadFile() {
    _mockUploadFile = _asyncToGenerator(function(file, onProgress) {
        var uploadSpeedBytesPerSecond, updatePeriodSeconds, loadedBytes;
        var _arguments = arguments;
        return __generator(this, function(_state) {
            switch(_state.label){
                case 0:
                    uploadSpeedBytesPerSecond = _arguments.length > 2 && _arguments[2] !== void 0 ? _arguments[2] : 500000, updatePeriodSeconds = _arguments.length > 3 && _arguments[3] !== void 0 ? _arguments[3] : 0.5;
                    loadedBytes = 0;
                    _state.label = 1;
                case 1:
                    if (!(loadedBytes < file.size)) return [
                        3,
                        3
                    ];
                    return [
                        4,
                        sleep(updatePeriodSeconds)
                    ];
                case 2:
                    _state.sent();
                    onProgress(new UploadProgress({
                        uploadProgressEvent: {
                            loaded: loadedBytes,
                            total: file.size
                        }
                    }));
                    loadedBytes += uploadSpeedBytesPerSecond * updatePeriodSeconds;
                    return [
                        3,
                        1
                    ];
                case 3:
                    return [
                        4,
                        sleep(updatePeriodSeconds)
                    ];
                case 4:
                    _state.sent();
                    return [
                        2,
                        {
                            token: "mockBlobToken",
                            md5Hash: "mockBlobMd5Hash",
                            name: file.name,
                            size: file.size
                        }
                    ];
            }
        });
    });
    return _mockUploadFile.apply(this, arguments);
}
